import React from "react";
import { string, object } from "prop-types";
import { Link } from "react-router-dom";
import Restricted from "./Restricted";

const Header = ({ title, button }) => (
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <div className="page-header clearfix">
          <h2 className="pull-left">{title}</h2>
          {button &&
            button.title &&
            button.link && (
              <Restricted accepted={["overmedia", "admin"]}>
                <Link
                  className="btn btn-primary pull-right mt20"
                  to={button.link}
                >
                  {button.title}
                </Link>
              </Restricted>
            )}
        </div>
      </div>
    </div>
  </div>
);

Header.propTypes = {
  title: string,
  button: object
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js